import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { throwError as observableThrowError, Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import _ from 'lodash';

import { ServiceProvider } from '../../service/provider.interface';

@Injectable()
export class RegistrationProvider extends ServiceProvider {
  private endPoint: string;
  private bannedUserNamesEndPoint: string;
  private countriesEndPoint: string;
  constructor(private http: HttpClient) {
    super();
    this.endPoint = this.config.apiEndpoints['registration'];
    this.bannedUserNamesEndPoint = this.config.apiEndpoints['bannedUserNames'];
    this.countriesEndPoint = this.config.apiEndpoints['countries'];
  }

  public getBannedUserNames = (): Observable<string[]> => {
    const url = this.bannedUserNamesEndPoint;
    return this.http.get(url).pipe(
      map(response => {
        const bannedUserNames: string[] = [];
        _.each(response, bannedUserName => {
          bannedUserNames.push(bannedUserName['name']);
        });
        return bannedUserNames;
      })
    );
  };

  public getCountries = (): Observable<any> => {
    let url = this.countriesEndPoint;
    return this.http
      .get(url)
      .pipe(
        catchError((response: HttpErrorResponse) => observableThrowError(response.error.message || 'Server error'))
      );
  };

  public postRegistration = (user: object): Observable<any> => {
    let url = this.endPoint;

    return this.http
      .post(url, user)
      .pipe(
        catchError((response: HttpErrorResponse) => observableThrowError(response.error.message || 'Server error'))
      );
  };
}
